import { combineReducers } from 'redux';
import * as Constants from '../../constants/filter';

export const f = (state = {}, action) => {
  switch (action.type) {
    case Constants.SET_USER_FILTER_STATE: {
      const newState = Object.assign({}, state);
      newState[action.userIdentifier] = newState[action.userIdentifier] || {};
      newState[action.userIdentifier][action.filterType] = action.value;
      return newState;
    }
    default:
      return state;
  }
};

export default combineReducers({
  f,
});

export const getMetricsFiltersState = (state = {}, userId,
  reportId, orgUuid) => {
  const userIdentifier = `${userId}#${reportId}#${orgUuid}`;
  const metricFilterState = (state.filterState && state.filterState.f
    && state.filterState.f[userIdentifier]);
  return ((metricFilterState && metricFilterState[Constants.USER_FILTER_METRICS]));
};

export const getDateFilterState = (state = {}, userId,
  reportId, orgUuid) => {
  const userIdentifier = `${userId}#${reportId}#${orgUuid}`;
  const metricFilterState = (state.filterState && state.filterState.f
    && state.filterState.f[userIdentifier]);
  return ((metricFilterState && metricFilterState[Constants.USER_FILTER_DATE]));
};
